import styled from 'styled-components'

import { TypeStyleBodyMicro } from '@syconium/little-miss-figgy'

import { gql } from '../../../../../__generated__/graphql/catalog/gql'
import { ColoredTextSegmentFragmentFragment } from '../../../../../__generated__/graphql/catalog/graphql'

export const ColoredTextSegmentFragment = gql(`
  fragment ColoredTextSegmentFragment on ColoredTextSegment {
   text
   color
  }
`)

export const ContentfulColoredText = ({
  segments,
  className,
}: {
  segments: ColoredTextSegmentFragmentFragment[]
  className?: string
}) => {
  return (
    <ColoredTextTypography className={className}>
      {segments.map((segment, i) => {
        switch (segment.color) {
          case 'PROMOTIONAL':
            return <TextColorPromotional key={i}>{segment.text}</TextColorPromotional>
          case 'SALE':
            return <TextColorSale key={i}>{segment.text}</TextColorSale>
          case 'DEFAULT':
            return <span key={i}>{segment.text}</span>
        }
      })}
    </ColoredTextTypography>
  )
}

const ColoredTextTypography = styled(TypeStyleBodyMicro)`
  font-weight: 600;
`

const TextColorPromotional = styled.span`
  color: ${o => o.theme.color.stroke.info.text.on.background};
`

const TextColorSale = styled.span`
  color: ${o => o.theme.color.stroke.critical.text.on.background};
`
